import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AdminPageLayout from '../../../layout/AdminPageLayout';
import { useSelector } from 'react-redux';
import { selectAdminRallies, setAdminRallies } from '../../../store/adminSlices/rallies';
import { useAppDispatch } from '../../../store';
import { getAdminRallies } from '../../../api/admin/rallies';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import PlusIcon from '../../../assets/icons/plus.svg';
import ButtonsGroup from '../../../ui/ButtonsGroup';
import AdminRallyInfoCard from '../../../ui/AdminRalliyInfoCard';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import { MODAL_CONTENT } from '../../../app.config.vars/modalContent';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '../../../app.config.vars/routes';
const ManageRalliesPage = () => {
    const { i18n, t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const rallies = useSelector(selectAdminRallies);
    useEffect(() => {
        const fetchRallies = async () => {
            try {
                const rallies = await getAdminRallies();
                dispatch(setAdminRallies(rallies));
            }
            catch (err) {
                dispatch(setIsModalOpen(true));
                dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
            }
        };
        fetchRallies();
    }, [i18n.language]);
    return (_jsx(AdminPageLayout, { logoutButton: true, children: _jsxs("div", { className: 'page-content-wrapper manage-rallies-page', children: [_jsx(Headline, { title: t('admin.manage_rallies'), type: 'h1' }), _jsx(ButtonsGroup, { children: _jsx(Button, { onClick: () => navigate(APP_ROUTES.adminCreateRally), label: t('admin.create_new_rally'), icon: _jsx(PlusIcon, {}), iconSize: 'small' }) }), rallies && (_jsxs("div", { className: 'rallies', children: [_jsx(Headline, { title: t('admin.your_rallies'), type: 'h1' }), _jsx("div", { className: "rallies-list", children: rallies.map((rally) => (_jsx(AdminRallyInfoCard, { uid: rally.uid, title: rally.publicTitle, internalTitle: rally.internalTitle, themes: rally.themes, geographicArea: rally.geographicArea, targetGroups: rally.targetGroups, isActive: rally.isActive, isComplete: rally.status === 1, hasStatistic: rally.hasStatistics, hasLocation: !!(rally.latitude && rally.longitude), uuid: rally.uuid }, rally.uid))) })] }))] }) }));
};
export default ManageRalliesPage;
